import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

import { computed } from 'vue'

import { useI18nAddon } from '@/i18n/i18n'

import LocaleSwitcher from './LocaleSwitcher.vue'

interface LocaleSwitcherListProps {
    size?: 'm' | 'l'
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LocaleSwitchersList',
  props: {
    size: { default: 'm' }
  },
  setup(__props: any) {

const props = __props

const i18nAddon = useI18nAddon()

const supportedLocales = computed(() => i18nAddon.getSupportedLocales())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.locale_switchers)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supportedLocales.value, (locale) => {
      return (_openBlock(), _createBlock(LocaleSwitcher, {
        key: locale,
        size: props.size,
        locale: locale
      }, null, 8, ["size", "locale"]))
    }), 128))
  ], 2))
}
}

})